import { Action, Selector, State, type StateContext } from "@ngxs/store";

import { Service } from "@angular/core";

import {
  ClearDefaultSettings,
  SetChargePreference,
  SetUserPreferences,
} from "./default-settings.actions";

export interface IChargePreference {
  enabled: boolean;
  amount: number;
}

export interface IUserPreferences {
  serviceCutApplyChargeDefault: IChargePreference;
  serviceReconnectionApplyChargeDefault: IChargePreference;
  meterChangeApplyLaborChargeDefault: IChargePreference;
  meterRemovalApplyLaborChargeDefault: IChargePreference;
}

export interface DefaultSettingsStateModel {
  userPreferences: IUserPreferences;
}

const DEFAULT_CHARGE_PREFERENCE = {
  enabled: false,
  amount: 0,
};

@State<DefaultSettingsStateModel>({
  name: "DefaultSettings",
  defaults: {
    userPreferences: {
      serviceCutApplyChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
      serviceReconnectionApplyChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
      meterChangeApplyLaborChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
      meterRemovalApplyLaborChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
    },
  },
})
@Service({ autoProvided: false })
export class DefaultSettingsState {
  @Selector()
  static userPreferences(state: DefaultSettingsStateModel): IUserPreferences {
    return state.userPreferences;
  }

  @Selector()
  static serviceCutApplyChargeDefault(state: DefaultSettingsStateModel) {
    return state.userPreferences.serviceCutApplyChargeDefault;
  }

  @Selector()
  static serviceReconnectionApplyChargeDefault(
    state: DefaultSettingsStateModel
  ) {
    return state.userPreferences.serviceReconnectionApplyChargeDefault;
  }

  @Selector()
  static meterChangeApplyLaborChargeDefault(state: DefaultSettingsStateModel) {
    return state.userPreferences.meterChangeApplyLaborChargeDefault;
  }

  @Selector()
  static meterRemovalApplyLaborChargeDefault(state: DefaultSettingsStateModel) {
    return state.userPreferences.meterRemovalApplyLaborChargeDefault;
  }

  @Action(SetUserPreferences)
  setUserPreferences(
    ctx: StateContext<DefaultSettingsStateModel>,
    action: SetUserPreferences
  ) {
    ctx.patchState({
      userPreferences: action.userPreferences,
    });
  }

  @Action(SetChargePreference)
  setChargePreference(
    ctx: StateContext<DefaultSettingsStateModel>,
    action: SetChargePreference
  ) {
    const currentPreferences = ctx.getState().userPreferences;
    ctx.patchState({
      userPreferences: {
        ...currentPreferences,
        [action.key]: action.preference,
      },
    });
  }

  @Action(ClearDefaultSettings)
  clearDefaultSettings(ctx: StateContext<DefaultSettingsStateModel>) {
    ctx.patchState({
      userPreferences: {
        serviceCutApplyChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
        serviceReconnectionApplyChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
        meterChangeApplyLaborChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
        meterRemovalApplyLaborChargeDefault: { ...DEFAULT_CHARGE_PREFERENCE },
      },
    });
  }
}
